﻿import { Injectable, EventEmitter, Inject } from '@angular/core';

export interface ICheckListItemChanged {
    checked: boolean,
    obj: any
}

export interface IChecksChanged {
    checkedItems: any[],
    uncheckedItems: any[]
}

@Injectable()
export class UserFormService {
    inputChanged: EventEmitter<any> = new EventEmitter<any>();
    isInvalid: boolean = true;
    hasChanges: boolean = false;
    setAsTouched: EventEmitter<any> = new EventEmitter<any>();
}